module.exports = "/_next/static/images/Quizhub-c79afb29411b697d2c9e69866b89d965.svg";